/* eslint-disable @typescript-eslint/naming-convention */
import {Type} from 'class-transformer';
import 'reflect-metadata';
import {Entity} from '../../core/main.entity';
import {BlockElementGalleryFilesViewList, BlockElementGalleryImagesViewList, BlockElementType} from '../enums';
import {BlockElement, BlockElementSettings} from './blockElement';
import {File} from '../file.entity';


export class BlockElementGallery extends BlockElement {
  type: BlockElementType = 'gallery';

  @Type(() => File)
  files?: File[] = [];

  @Type(() => BlockElementGallerySettings)
  settings?: BlockElementGallerySettings = new BlockElementGallerySettings();
}

export class BlockElementGallerySettings extends BlockElementSettings {
  filesView?: BlockElementGalleryFilesViewList = 'grid';
  imagesView?: BlockElementGalleryImagesViewList = 'slider';
}
